import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30.1 30.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0v30.1h30.1V0zm11.19 21.27c.33.32.71.47 1.18.47h10.55l-.05 3.51H12.4c-1.47 0-2.72-.49-3.71-1.45-1-.98-1.51-2.21-1.51-3.69V9.98c0-1.48.51-2.71 1.51-3.69.99-.96 2.24-1.45 3.71-1.45h10.47l.05 3.51H12.37c-.47 0-.85.15-1.18.47-.32.31-.48.69-.48 1.16v10.13c0 .47.16.85.48 1.16"
    }, null, -1)
  ]))]))
}
export default { render: render }